export default "__VITE_ASSET__B9w09Nfj__"